import React from 'react'
import styled from 'styled-components'

import { FlexContainer } from '../Layout/flex'

import Icon from '../Icon'
import { ActionModule, ModuleList } from '../Module'
import { SearchField } from '../forms'

const FilterList = styled.div`
  padding: 1rem;
  border-left: 1px solid ${(props) => props.theme.colors.gray};
  flex: 2;
  display: flex;
  flex-direction: column;
`

const ValveFilterList = ({
  filterText,
  moduleValue,
  valveValue,
  modules,
  valves,
  filters,
  onFilter,
  setFilters,
  onAdd,
  deactivatedValves,
}) => {
  const canAdd = (addableId) =>
    !deactivatedValves.find(({ id }) => id === addableId)
  return (
    <FilterList>
      <SearchField
        list="searchSuggestions"
        value={filterText}
        onChange={onFilter}
      />
      <datalist id="searchSuggestions">
        {modules.map((module, index) => (
          <option key={index} value={moduleValue(module)} />
        ))}
        {valves.map((valve, index) => (
          <option key={modules.length + index} value={valveValue(valve)} />
        ))}
      </datalist>
      <FlexContainer marginBottom>
        {filters.map(([attr, value, text, icon], index) => {
          return (
            <span key={index}>
              <Icon small text name={icon} />
              {text}
              <Icon
                small
                text
                bordered={false}
                name="cancel"
                onClick={() =>
                  setFilters([
                    ...filters.slice(0, index),
                    ...filters.slice(index + 1),
                  ])
                }
              />
            </span>
          )
        })}
      </FlexContainer>
      <ModuleList>
        {valves
          .filter((valve) =>
            filters.reduce(
              (isVisible, [attr, value]) => isVisible && valve[attr] === value,
              true
            )
          )
          .map(({ name, id }) => (
            <ActionModule
              onLeftClick={onAdd && canAdd(id) ? () => onAdd(id) : null}
              key={id}
              toRight={`/valves/${id}/edit`}
            >
              {name}
            </ActionModule>
          ))}
      </ModuleList>
    </FilterList>
  )
}

export default ValveFilterList
